(ns global.endor.checkout.config)

(goog-define DEV_MODE false)
